import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact  from "highcharts-react-official";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import Exporting from "highcharts/modules/exporting"
import Bellcurve from 'highcharts/modules/histogram-bellcurve'
Exporting(Highcharts);
NoDataToDisplay(Highcharts);
Bellcurve(Highcharts);
class Histogram extends React.Component {
  render() {
    const {
      title,
      xTitle,
      yTitle,
      categories,
      className,
      data,
      additionalOptions
    } = this.props
    const options = {
      title: {
          text: title
      },
      xAxis: [{
        title: {
          text: ''
        }
      }, {
        title: {
          text: xTitle ? xTitle : ''
        }
      }],
      yAxis: [{
          title: {
              text: ''
          }
      }, {
        title: {
          text: yTitle ? yTitle : ''
        }
      }],
      series: [
        {
          type: "histogram",
          name: "Histogram",
          xAxis: 1,
          yAxis: 1,
          baseSeries: 1,
        },
        {
          data: data,
          visible: false,
        },
      ],
      credits: {
        enabled: false
      },
      lang: {
        noData: "No data available"
      }
    };
    if (additionalOptions) {
      Object.assign(options, additionalOptions); 
    }
    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} containerProps={{ className: className }} />
      </div>
    );
  }
}
export default Histogram